<template>
  <div class="time-content">
    <div class="timeList df" :style="{width:typePage?'90%':'100%'}">
      <div class="timeLft" @click="leftTime('last')">
        <i class="iconfont iconleft-arrow" :class="{'color-iconfont':!weekBtnStatu}"></i>
      </div>
      <transition name="slide">
        <div class="timeC" v-if="show">
          <div
            class="timeItem itemStyle"
            v-for="(item,indextime) in weekList"
            :key="indextime"
            :class="{'active':item.statu}"
            @click="setTime(item)"
          >
            <div>
              <p style="color:#ff6600;font-size:17px;" v-if="typePage">
                <span v-show="item.price">
                  <i style="font-size:12px;color:#666;font-style:normal">￥</i>
                  {{item.price}}
                </span>
                <!-- <span v-else>暂无</span> -->
              </p>
              <p v-if="typePage">
                {{item.date.split('-')[1]+'-'+item.date.split('-')[2]}}
                {{item.week}}
              </p>
              <p v-else>{{item.date}}</p>
              <p v-if="!typePage">{{item.week}}</p>
            </div>
          </div>
        </div>
      </transition>
      <div class="timeRight" @click="leftTime('next')">
        <i class="iconfont iconright-arrow"></i>
      </div>
    </div>
    <div class="calendar-box" v-if="typePage">
      <i class="el-icon-date"></i>
      <span id="init">查看30天最低价</span>
    </div>
    <transition name="fade">
      <div
        class="clendar-upbox"
        v-show="fullCalendarShow"
        @mouseenter="calendarStatu = true"
        @mouseleave="calendarStatu = false"
      >
        <FullCalendar @dayClick="dayClick" :events="events"/>
      </div>
    </transition>
  </div>
</template>
<script>
import FullCalendar from "@/page/distributor/component/FullCalendar/flight-calendar";
import getClendarPrice from "@/lib/data-service/flight/buyer_dom_white_flight_lowestPrice";
export default {
  name: "Calendar",
  data() {
    return {
      weekBtnStatu: true,
      weekList: [],
      calendarStatu: false,
      show: true,
      fullCalendarShow: false,
      airData: {},
      _saveWeek: "",
      events: []
    };
  },
  created() {
    window.addEventListener("click", this.cutShow);
  },
  destroyed() {
    window.removeEventListener("click", this.cutShow, false);
  },
  props: {
    typePage: {
      type: Boolean,
      default: false
    },
    saveWeek: String,
    initStatu: Number
  },
  components: { FullCalendar },
  watch: {
    initStatu(val) {
      this._saveWeek = this.saveWeek;
      val ? this.getDayList() : "";
    }
  },
  mounted() {
    //初始刷新日历列表
    this._saveWeek = this.saveWeek;
    this.getDayList();
  },
  methods: {
    getPrice() {
      let formData = this.$parent;
      let endTime = new Date().valueOf() + 24 * 3600 * 1000 * 29;
      let data = {
        arrCode: formData.endCity,
        depCode: formData.starCity,
        startDate: this.$moment().format("YYYY-MM-DD"),
        endDate: this.$moment(endTime).format("YYYY-MM-DD"),
        supplierType: 1
      };
      getClendarPrice(data).then(res => {
        if (res.result) {
          this.events = res.result;
          this.setPrice();
        }
      });
    },
    setPrice() {
      this.weekList.map(item => {
        this.events.map(day => {
          if (item.date === day.depDate) {
            item.price = day.ticketPrice;
          }
        });
      });
    },
    cutShow(e) {
      if (!this.calendarStatu && this.fullCalendarShow) {
        this.fullCalendarShow = false;
      }
      if (e.target.id === "init") {
        this.fullCalendarShow = true;
      }
    },
    setTime(val) {
      this.weekList.map(item => {
        item.statu = false;
      });
      val.statu = true;
      this.$emit("clickDate", val.date);
    },
    dayClick(val) {
      let date1 = new Date(val.date).valueOf();
      let date = new Date().valueOf();
      if (date1 < date) return;
      this.fullCalendarShow = false;
      this._saveWeek = val.date.format("YYYY-MM-DD");
      this.getDayList();
      this.$emit("clickDate", val.date.format("YYYY-MM-DD"));
    },
    getDayList(val) {
      let now = new Date().valueOf();
      let location = this.locationDay(3);
      if (location - now <= 0) {
        this._getWeek();
        this.weekBtnStatu = false;
      } else {
        this._getWeek(location);
        this.weekBtnStatu = true;
      }
      this.typePage ? this.getPrice() : "";
    },
    locationDay(val) {
      return Date.parse(this._saveWeek) - val * Math.floor(24 * 3600 * 1000);
    },
    _getWeek(val) {
      let arr = [];
      val ? val : "";
      for (let i = 0; i < 7; i++) {
        let dateTime = this.$moment(val)
          .subtract(-i, "days")
          .format("YYYY-MM-DD");
        let week = this.$moment(val).subtract(-i, "days")._d;
        week = week.getDay();
        week =
          week === 0
            ? "星期日"
            : week === 1
              ? "星期一"
              : week === 2
                ? "星期二"
                : week === 3
                  ? "星期三"
                  : week === 4
                    ? "星期四"
                    : week === 5
                      ? "星期五"
                      : "星期六";
        let obj = {
          week: week,
          date: dateTime,
          statu: false
        };
        arr.push(obj);
      }
      this.weekList = arr;
      if (this._saveWeek) {
        arr.map((item, index) => {
          item.date === this._saveWeek ? (item.statu = true) : "";
        });
      }
      this.setPrice();
    },
    leftTime(val) {
      let _this = this;
      if (val == "next") {
        this.dayShow();
        this._getWeek(this.weekList[6].date);
        this.weekBtnStatu = true;
      } else if (val == "last") {
        if (!this.weekBtnStatu) return;
        this.dayShow();
        let date = this.$moment(this.weekList[0].date)
          .subtract("days", 6)
          .format("YYYY-MM-DD");
        let now = this.$moment().format("YYYY-MM-DD");
        let dayNum = Date.parse(date) - Date.parse(now);
        if (dayNum <= 0) {
          this._getWeek(now);
        } else {
          this._getWeek(date);
        }
        if (date.valueOf() <= now.valueOf()) {
          this.weekBtnStatu = false;
        }
      }
    },
    dayShow() {
      this.show = false;
      setTimeout(() => {
        this.show = true;
      });
    },
    datedifference(sDate1, sDate2) {
      var dateSpan,
        tempDate,
        iDays,
        sDate1 = Date.parse(sDate1);
      sDate2 = Date.parse(sDate2);
      dateSpan = sDate2 - sDate1;
      dateSpan = Math.abs(dateSpan);
      iDays = Math.floor(dateSpan / (24 * 3600 * 1000));
      return iDays;
    }
  }
};
</script>
<style lang="less" scoped>
.time-content {
  width: 100%;
  height: 64px;
  margin: 20px 0;
  display: flex;
  position: relative;
}
.timeList {
  min-width: 90%;
  overflow: hidden;
  height: 100%;
  background-color: #f3f9fe;
  .color-iconfont {
    color: #cfc8cc;
  }
  .timeC {
    width: calc(100% - 104px);
    height: 100%;
    border: solid 1px #ececec;
    overflow: hidden;
    display: flex;
    .active {
      border-top: 2px solid #378ded;
      background: #fff;
      color: #378ded;
      font-weight: bold;
      i {
        font-weight: 400;
      }
    }
  }
  .timeLft,
  .timeRight {
    width: 52px;
    height: 100%;
    z-index: 1000;
    border: solid 1px #ececec;
    background: #fff;
    color: #64aae4;
    cursor: pointer;
    i {
      display: inline-block;
      text-align: center;
      font-size: 32px;
      line-height: 64px;
      width: 52px;
    }
    &:hover {
      color: #378ded;
    }
  }
  .timeLft {
    border-right: none;
  }
  .timeRight {
    border-left: none;
  }
}
.timeItem {
  width: calc(100% / 7);
  text-align: center;
  color: #7d7d7d;
  height: 100%;
  // line-height: 30px;
  cursor: pointer;
  border-top: 2px solid transparent;
  border-left: 1px solid #ececec;
  display: flex;
  align-items: center;
  justify-content: center;
}
.df {
  display: flex;
}
.slide-enter-active {
  transition: all 0.3s ease;
}
.slide-leave-active {
  transition: all 0.8s cubic-bezier(1, 0.5, 0.8, 1);
}
.slide-enter,
.slide-leave-to {
  transform: translateX(100px);
  opacity: 0;
}
.calendar-box {
  width: 10%;
  height: 100%;
  font-size: 12px;
  color: #4b4b4b;
  border: 1px solid #dfdfdf;
  border-left: 0;
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 0 10px;
  span {
    cursor: pointer;
    &:hover {
      color: #237dc9;
    }
  }
  i {
    font-size: 30px;
    margin-right: 8px;
    color: #4f96e9;
  }
}
.clendar-upbox {
  width: 600px;
  min-height: 300px;
  position: absolute;
  right: 180px;
  top: 50%;
  background: white;
  z-index: 9999;
  transform: translate(0, -50%);
}

.fade-enter-active {
  transition: all 0.3s ease;
}
.fade-leave-active {
  transition: all 0.3s ease;
}
.fade-enter,
.fade-leave-to {
  transform: translateY(50px);
  opacity: 0;
}
.itemStyle {
  font-size: 13px;
  // line-height: 20px;
  p {
    line-height: 29px;
  }
}
</style>